export const prefersReducedMotion = (): boolean =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;

// jsdom has no Web Animations; without it the motion simply cuts.
export const canAnimate = <T extends Element>(el: T | null): el is T =>
  !!el && typeof el.animate === "function";

/// Motion tokens as WAAPI wants them; the CSS custom property is the source.
export const motionToken = (name: string, fallback: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim() ||
  fallback;

export const durationMs = (name: string, fallback: number): number => {
  const value = motionToken(name, `${fallback}ms`);
  const ms = parseFloat(value);
  return value.endsWith("ms") ? ms : value.endsWith("s") ? ms * 1000 : fallback;
};
